import { MatTableDataSource } from '@angular/material/table';
import { Equipo } from 'src/app/administracion/modelos/Inventario/Equipo/equipo';

export class Paginacion {
  page: number;
  size: number;
  totalElements: number;

  constructor(page: number, size: number, totalElements: number) {
    this.page = page;
    this.size = size;
    this.totalElements = totalElements;
  }
}

export class EstadoGestionEquipo {
  private _data: Equipo[] = [];
  private _datasource = new MatTableDataSource<Equipo>([]);

  estados: string[] = [];
  paginacion = new Paginacion(0, 20, 0);

  estado: 'inicial' | 'cargando' | 'exito' | 'error' = 'inicial';

  constructor(estados: string[]) {
    this.estados = estados;
  }

  set data(value: Equipo[]) {
    this._data = value;
    this._datasource = new MatTableDataSource<Equipo>(value);
  }

  get data() {
    return this._data;
  }

  get datasource() {
    return this._datasource;
  }
}
